import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import { createResource } from '@gandi/redux-resource';
import { selectCurrentId } from '@gandi/redux-sharing';
import { selectRaw as selectRawState, selectSharingIdProp } from './utils';
var selectCountryProp = function selectCountryProp(state) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    country: undefined
  };
  return props.country;
};
var computeLabel = function computeLabel(_ref) {
  var sharingId = _ref.sharingId,
    country = _ref.country;
  return country ? "".concat(sharingId, ".").concat(country) : sharingId;
};
export var resource = createResource('billing.billing.currencies');
export var selectIsFetching = function selectIsFetching(state, props) {
  return resource.selectIsFetching(state, computeLabel(props));
};
export var selectIsLoaded = function selectIsLoaded(state, props) {
  return resource.selectIsLoaded(state, computeLabel(props));
};
export var selectIsFailure = function selectIsFailure(state, props) {
  return resource.selectIsFailure(state, computeLabel(props));
};
export var selectIsToRefetch = function selectIsToRefetch(state, props) {
  return resource.selectIsToRefetch(state, computeLabel(props));
};
export var selectRaw = createSelector([selectRawState], function (raw) {
  return raw.currencies;
});
var getCurrencies = function getCurrencies(raw) {
  var sharingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var country = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return raw[computeLabel({
    sharingId: sharingId,
    country: country
  })];
};
export var selectCurrencies = createSelector([selectRaw, selectSharingIdProp, selectCountryProp], getCurrencies);
export var selectCurrenciesForCurrent = createSelector([selectRaw, selectCurrentId, selectCountryProp], getCurrencies);
var getDefaultCurrency = function getDefaultCurrency() {
  var currencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return currencies.default;
};
export var selectDefaultCurrency = createSelector([selectCurrencies], getDefaultCurrency);
export var selectDefaultCurrencyForCurrent = createSelector([selectCurrenciesForCurrent], getDefaultCurrency);
var getAvailableCurrencies = function getAvailableCurrencies() {
  var currencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return currencies.currencies;
};
export var selectAvailableCurrencies = createSelector([selectCurrencies], getAvailableCurrencies);
export var selectAvailableCurrenciesForCurrent = createSelector([selectCurrenciesForCurrent], getAvailableCurrencies);
export var fetchCurrencies = function fetchCurrencies() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    country: undefined,
    sharingId: undefined,
    params: undefined
  };
  return function (dispatch, getState) {
    var country = options.country;
    var currentId = selectCurrentId(getState());
    var sharingId = options.sharingId || currentId;
    if (typeof sharingId !== 'string') {
      return _Promise.reject(new Error('[billing.currencies] `fetchCurrencies` called without `sharingId` option' + ' nor @gandi/redux-sharing dep/state.'));
    }
    var label = computeLabel({
      sharingId: sharingId,
      country: country
    });
    return dispatch(resource.fetch('/billing/currencies', _objectSpread(_objectSpread({}, options), {}, {
      label: label,
      params: _objectSpread(_objectSpread({}, options.params || {}), {}, {
        country: country,
        sharing_id: sharingId
      }),
      on200: function on200(response) {
        return response;
      },
      not200: function not200(response) {
        return _Promise.reject(response);
      }
    })));
  };
};
var reducer = createReducer(_defineProperty({}, resource.fetch.success.getType(), function (state, _ref2) {
  var data = _ref2.response.data,
    label = _ref2.label;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, label, data));
}), {});
export default reducer;